// English translations
const en = {
  common: {
    loading: 'Loading…', save: 'Save', cancel: 'Cancel', back: 'Back',
    edit: 'Edit', logout: 'Log out', comingSoon: 'COMING SOON',
    error: 'Something went wrong', retry: 'Retry', ofAura: 'AURA',
    yes: 'Yes', no: 'No', confirm: 'Confirm', publish: 'Publish',
    delete: 'Delete', more: 'More',
  },
  nav: {
    home: 'Home', battles: 'Battles', create: 'Create', ranking: 'Ranking',
    discover: 'Discover', profile: 'Profile', admin: 'Admin',
    notifications: 'Notifications', search: 'Search', saved: 'Saved',
  },
  auth: {
    title: 'Enter the Aura', subtitle: 'Farm your Aura. Rise through the ranks.',
    signIn: 'Sign In', signUp: 'Sign Up',
    signInWithGoogle: 'Continue with Google', signInWithPhone: 'Continue with phone',
    orDivider: 'or',
    phone: 'Phone number', phoneHint: 'Include country code, e.g. +52 55 0000 0000',
    password: 'Password', passwordHint: '8+ characters',
    name: 'Full name',
    username: 'Username', usernameHint: '3-24 chars, letters, numbers and _',
    usernameChecking: 'Checking…', usernameAvailable: '✓ Available', usernameTaken: '✗ Already taken',
    birthdate: 'Birth date', country: 'Country', state: 'State / Province', city: 'City',
    acceptTerms: 'I accept the Terms of Service', acceptPrivacy: 'I accept the Privacy Policy',
    acceptCommunity: 'I accept the Community Rules',
    submitSignIn: 'Enter', submitSignUp: 'Start farming Aura',
    switchToSignUp: "Don't have an account? Sign up",
    switchToSignIn: 'Already have an account? Sign in',
    errorInvalid: 'Invalid credentials', errorAccept: 'You must accept the required documents',
  },
  profile: {
    edit: 'Edit profile', follow: 'Follow', following: 'Following', unfollow: 'Unfollow',
    challenge: 'Challenge to Battle',
    followers: 'Followers', followingLabel: 'Following',
    posts: 'Posts', battles: 'Battles', wins: 'Wins', losses: 'Losses', ties: 'Ties',
    winRate: 'Win Rate', streak: 'Streak', bestStreak: 'Best Streak',
    localRank: 'Local Rank', nationalRank: 'National Rank', worldRank: 'World Rank',
    badges: 'Badges', noBadges: 'No badges yet — win a battle to earn your first one.',
    auraHistory: 'Aura History', noTransactions: 'No Aura movements yet.',
    nextLevel: 'to', progressLabel: 'Progress',
    bio: 'Bio', bioPlaceholder: 'Tell the community about your Aura…',
    changeAvatar: 'Change avatar', uploadAvatar: 'Upload avatar',
    saved: 'Profile saved',
    yourQr: 'Your Aura QR', scanToView: 'Scan to view profile',
    copyLink: 'Copy link', linkCopied: 'Link copied',
    tabs: { posts: 'POSTS', battles: 'BATTLES', aura: 'AURA', badges: 'BADGES' },
    noPosts: 'No posts yet.',
    topMoments: 'Top Aura Moments',
    myStats: 'My Stats',
  },
  home: {
    heroTitle: 'Farm your Aura',
    heroSub: 'Your energy in numbers. Post moments, win battles, climb the ranks.',
    yourAura: 'Your Aura',
    trendingSoon: 'Battles arriving in the next drop',
  },
  feed: {
    tabForYou: 'FOR YOU',
    tabFollowing: 'FOLLOWING',
    empty: 'Nothing here yet — follow creators to fill this feed.',
    emptyForYou: 'The Aura is warming up. Be the first to drop a moment.',
    signInToComment: 'Sign in to comment.',
    comments: 'Comments', noComments: 'Be the first to comment.',
    reply: 'Reply', replyingTo: 'Replying to',
    commentPlaceholder: 'Add a comment…',
    linkCopied: 'Link copied',
    reactionsLabel: 'Aura reactions', viewsLabel: 'views',
    delete: 'Delete post', deleted: 'Post deleted',
    confirmDelete: 'Delete this post permanently?',
    report: 'Report', mute: 'Mute user', blocked: 'User blocked',
    muted: 'User muted', block: 'Block user',
    reportSubmitted: 'Report submitted',
    reportDescPlaceholder: 'Add more details (optional)…',
    reportReasons: {
      harassment: 'Harassment', threats: 'Threats', hate_speech: 'Hate speech',
      sexual_content: 'Sexual content', violence: 'Violence', spam: 'Spam',
      aura_fraud: 'Aura fraud', impersonation: 'Impersonation',
      privacy: 'Privacy', minor_content: 'Minor content', other: 'Other',
    },
    liveBattleTitle: 'AURA BATTLE LIVE',
    watchBattle: 'Watch battle',
    voteNow: 'Vote now',
    createTitle: 'What are you sharing?',
    create: {
      aura_moment: 'Aura Moment', aura_momentDesc: 'A performance, style or vibe that generates Aura',
      video: 'Video', videoDesc: 'Up to 60s vertical video',
      photo: 'Photo', photoDesc: 'One photo with caption',
      text: 'Text', textDesc: 'Up to 500 chars',
      positive: 'Positive Action', positiveDesc: 'Recognize a positive act (Community Aura)',
    },
    createText: 'New text post', createPhoto: 'New photo', createVideo: 'New video',
    createAuraMoment: 'New Aura Moment', createPositive: 'Positive Action',
    caption: 'Caption', captionPlaceholder: 'What is this moment about?',
    textPlaceholder: 'Share something worth Aura…',
    category: 'Category', privacy: 'Who can see?',
    privacyPublic: 'Public', privacyFollowers: 'Followers', privacySelf: 'Only me',
    picture: 'Pick a photo', picVideo: 'Pick a video', pickFile: 'Choose file',
    publishing: 'Publishing…', published: 'Published',
    positiveNotice: 'Recognizing an action grants Aura only after Community Aura reviews it with witnesses. Available in an upcoming update.',
    videoTooLong: 'Video too long. Max 60 seconds.',
  },
  discover: {
    title: 'Discover', trending: 'Trending', creators: 'Top creators',
    categories: 'Categories', hashtags: 'Hashtags',
  },
  notifications: {
    title: 'Notifications', tabs: { all: 'All', battles: 'Battles', aura: 'Aura', social: 'Social' },
    markRead: 'Mark all read', empty: 'No notifications yet.',
    types: {
      follow: 'started following you',
      reaction: 'reacted to your post',
      comment: 'commented on your post',
      reply: 'replied to your comment',
      mention: 'mentioned you',
      tag: 'tagged you',
      battle: 'battle activity',
      vote: 'voted on your battle',
      aura_recognized: 'Aura recognized',
      badge: 'Badge earned',
    },
  },
  search: {
    title: 'Search', placeholder: 'Search users, hashtags, posts…',
    users: 'Users', hashtags: 'Hashtags', posts: 'Posts',
    empty: 'Start typing to find someone.',
    noResults: 'No results.',
  },
  admin: {
    title: 'Admin Console', totalUsers: 'Total users', activeUsers: 'Active users',
    newUsers7d: 'New (7d)', totalAura: 'Aura generated', distribution: 'Level distribution',
    userList: 'Users', search: 'Search…',
    notAllowed: 'You do not have permission to access this area.',
    content: 'Content', reports: 'Reports',
  },
  levels: { npc: 'NPC', rookie: 'Rookie Aura', farmer: 'Aura Farmer',
    master: 'Aura Master', legend: 'Aura Legend', god: 'AURA GOD', max: 'MAX LEVEL' },
  toast: { followed: 'Following', unfollowed: 'Unfollowed', error: 'Action failed' },
  qr: {
    copied: 'Link copied', shareText: 'Battle me on AURA',
    scan: 'Scan opponent', share: 'Share', copyLink: 'Copy link',
    privacyTitle: 'Who can challenge me',
    privacy: { all: 'Everyone', followers: 'My followers', following: 'People I follow', none: 'Nobody' },
  },
  scan: {
    title: 'Scan opponent', subtitle: 'Point your camera at their Aura QR',
    invalid: 'Invalid Aura QR', cameraDenied: 'Camera permission denied',
    youScanned: 'You scanned',
    challenge: 'Challenge to battle', challengeSent: 'Challenge sent',
    scanAgain: 'Scan again',
    reasonClosed: 'This user is not accepting challenges right now.',
    reasonSelf: 'This is your own QR.',
    reasonFollowers: 'Only their followers can challenge them.',
    reasonFollowing: 'Only people they follow can challenge them.',
  },
  battles: {
    myQr: 'My Aura QR', scanOpponent: '⚔️ Scan opponent',
    incoming: 'Incoming challenges', outgoing: 'Outgoing', waiting: 'Waiting for response…',
    accepted: 'Battle accepted!', declined: 'Challenge declined',
    live: 'LIVE BATTLES', noLive: 'No battles happening right now — scan an opponent to start one.',
    watch: 'Watch battle', preparing: 'Get ready', voteNow: 'VOTE NOW',
    history: 'History',
  },
  battle: {
    preparing: 'Preparing', liveNow: 'Live now', votingOpen: 'Voting open',
    startsIn: 'BATTLE STARTS IN', startBattle: 'Start battle', openVoting: 'Open voting',
    closesIn: 'Voting closes in',
    voteFor: 'Vote for',
    voteRecorded: 'Your vote has been recorded',
    waitResults: 'Results will appear when voting closes.',
    contestantsCannotVote: 'Contestants cannot vote on their own battle.',
    cannotVote: 'You cannot vote on this battle.',
    tied: 'TIED', tiedDesc: 'A judge or a rematch will decide.',
    winner: 'WINNER',
    votes: 'votes', totalVotes: 'total votes',
    auraAwarded: 'Aura Awarded',
  },
};
export default en;
